import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: {
      position: 'relative',
      // color: scssVariables.ColorBlack60,
      height: '42px',
      width: '42px',
      svg: {
        display: 'none',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '18px',
        height: '18px',
        borderRadius: '4px',
        border: `1px solid ${scssVariables.ColorBlack40}`,
        backgroundColor: scssVariables.ColorBlack00,
        transition: 'all 50ms ease-out',
      },
      '&::after': {
        content: '"check"',
        fontFamily: 'Material Symbols Rounded',
        fontSize: '16px',
        fontVariationSettings: `"FILL" 0, "wght" 600, "GRAD" 0`,
        display: 'inline-block',
        zIndex: 1,
        opacity: 0,
        transform: 'scale(0)',
        transition: 'all 80ms ease-out',
        pointerEvents: 'none',
      },
      '&:hover:not(.Mui-checked, .Mui-disabled)': {
        '&::before': {
          border: `1px solid ${scssVariables.ColorBlue80}`,
        },
      },
      '&.Mui-checked': {
        color: scssVariables.ColorBlue80,
        svg: {
          display: 'none',
        },
        '&::before': {
          border: `2px solid ${scssVariables.ColorBlue80}`,
          backgroundColor: scssVariables.ColorBlue10,
        },
        '&::after': {
          opacity: 1,
          transform: 'scale(1)',
        },
      },

      '&.Mui-disabled': {
        pointerEvents: 'auto',
        cursor: 'not-allowed',
        opacity: 0.6,
      },
    },
  },
  variants: [
    {
      props: { size: 'small' },
      style: {
        height: 'var(--input-height-small)',
        width: 'var(--input-height-small)',
        '&::before': {
          width: '16px',
          height: '16px',
        },
        '&::after': {
          fontSize: '14px',
        },
      },
    },
    {
      props: { size: 'medium' },
      style: {
        height: 'var(--input-height-medium)',
        width: 'var(--input-height-medium)',
        '&::before': {
          width: '18px',
          height: '18px',
        },
        '&::after': {
          fontSize: '16px',
        },
      },
    },
    {
      props: { size: 'large' },
      style: {
        height: 'var(--input-height-large)',
        width: 'var(--input-height-large)',
        '&::before': {
          width: '22px',
          height: '22px',
        },
        '&::after': {
          fontSize: '20px',
        },
      },
    },
  ],
};
